import { Text } from '@/components/atoms/Text';
import { Title } from '@/components/atoms/Title';
import styled from '@emotion/styled';

export const PanelTitle = styled(Title)`
    color: ${({ theme }) => theme.color.black};
    margin-bottom: ${({ theme }) => theme.savory.spacing[2]};
    font-size: ${({ theme }) => theme.font.size.large};
`;

export const PanelText = styled(Text)`
    color: ${({ theme }) => theme.color.black};
`;

export const ConfigWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const SuccessMessage = styled.p`
    color: ${({ theme }) => theme.savory.colors.success[600]};
`;
